import React from 'react';
import Button from '@mui/material/Button';

const CustomButton = ({ children, className = '', ...props }) => {
  return (
    <Button
      variant="contained"
      className={`!bg-blue-600 hover:!bg-blue-700 !text-white !rounded-md !py-2 !px-6 shadow-md transition-all duration-200 ${className}`}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton; 